import { request3 } from '../../utils/request'
import { urlStringify } from '../../utils/index'
export default {
  // 查询合伙人列表
  getcoupons: option => {
    return request3('v1/coupon/getcoupons', option, true)
  },
  addcoupon: option => {
    return request3('v1/coupon/addcoupon', option, true)
  },
  // 查询合伙人信息
  getcouponnumbers: option => {
    return request3('v1/coupon/getcouponnumbers', option, true)
  },
  // 禁用
  invalidcouponnumber: option => {
    const urls = urlStringify(option)
    return request3('v1/coupon/invalidcouponnumber' + urls, {}, true)
  },
  // 禁用
  enablecoupon: option => {
    const urls = urlStringify(option)
    return request3('v1/coupon/enablecoupon' + urls, {}, true)
  },
  // 禁用
  disenablecoupon: option => {
    const urls = urlStringify(option)
    return request3('v1/coupon/disenablecoupon' + urls, {}, true)
  },
  // 禁用
  increasecouponcount: option => {
    const urls = urlStringify(option)
    return request3('v1/coupon/increasecouponcount' + urls, {}, true)
  },

  getscancodegifts: option => {
    return request3('v1/scancodegift/getscancodegifts', option, true)
  },
  getscancodegift: option => {
    const urls = urlStringify(option)
    return request3('v1/scancodegift/getscancodegift' + urls, {}, true)
  },
  getscancodegiftrecords: option => {
    return request3('v1/scancodegift/getscancodegiftrecords', option, true)
  },
  addscancodegift: option => {
    return request3('v1/scancodegift/addscancodegift', option, true)
  },
  updatescancodegift: option => {
    return request3('v1/scancodegift/updatescancodegift', option, true)
  }
}
